import { render, staticRenderFns } from "./MembersProvidersSideBar.vue?vue&type=template&id=d1f50628&"
import script from "./MembersProvidersSideBar.vue?vue&type=script&lang=js&"
export * from "./MembersProvidersSideBar.vue?vue&type=script&lang=js&"
import style0 from "./MembersProvidersSideBar.vue?vue&type=style&index=0&id=d1f50628&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports